// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-form-content {
    display: flex;
    flex-direction: row;
    gap: 16px;
    cursor: pointer;
    position: relative;
}

.survey-form-content.survey-form-content-card {
    background-color: var(--survey-content-card-background-color);
    padding: 8px 16px;
    border-radius: 6px;
}

.survey-form-content.survey-form-content-middle-align {
    align-items: center;
}
.survey-form-content.survey-form-content-top-align {
    align-items: flex-start;
}

.survey-form-content .survey-form-content-icon {
    line-height: 1.3;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--survey-card-background-color);
    white-space: nowrap;
    margin-top: 8px;
    margin-bottom: 8px;
}

.survey-form-content .survey-form-content-icon.medium {
    height: 40px;
    width: 40px;
    min-width:40px;
    border-radius: 20px;
}
.survey-form-content .survey-form-content-icon.large {
    height: 60px;
    width: 60px;
    min-width:60px;
    border-radius: 30px;
    font-size: 30px;
}

.survey-form-content .survey-form-item {
    width: 100%;
    position: initial;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Components/SurveyFormContentItem/SurveyFormContentItem.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,6DAA6D;IAC7D,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qDAAqD;IACrD,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".survey-form-content {\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    cursor: pointer;\n    position: relative;\n}\n\n.survey-form-content.survey-form-content-card {\n    background-color: var(--survey-content-card-background-color);\n    padding: 8px 16px;\n    border-radius: 6px;\n}\n\n.survey-form-content.survey-form-content-middle-align {\n    align-items: center;\n}\n.survey-form-content.survey-form-content-top-align {\n    align-items: flex-start;\n}\n\n.survey-form-content .survey-form-content-icon {\n    line-height: 1.3;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--survey-card-background-color);\n    white-space: nowrap;\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n.survey-form-content .survey-form-content-icon.medium {\n    height: 40px;\n    width: 40px;\n    min-width:40px;\n    border-radius: 20px;\n}\n.survey-form-content .survey-form-content-icon.large {\n    height: 60px;\n    width: 60px;\n    min-width:60px;\n    border-radius: 30px;\n    font-size: 30px;\n}\n\n.survey-form-content .survey-form-item {\n    width: 100%;\n    position: initial;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
